import * as Yup from "yup";
import {
  resolveRRDStoreCopyConfig,
  validateRRDStoreCopyQuantity,
} from "./rrdStoreCopyConfigHelper";

type RRDStoreCopyValidationArgs = {
  storeCopyQnt?: any;
  storeCopy?: any;
  storeCopyConfig?: Record<string, any>;
  config?: Record<string, any>;
};

type RRDMailingDateValidationArgs = {
  mailing_date?: any;
};

type RRDValidLocation = {
  id: string | number;
};

export const validateStoreCopyQuantity = ({
  storeCopyQnt,
  storeCopy,
  storeCopyConfig,
  config,
}: RRDStoreCopyValidationArgs = {}) => {
  const resolvedConfig =
    config ||
    storeCopyConfig ||
    resolveRRDStoreCopyConfig({ location: storeCopyConfig || {} });

  return validateRRDStoreCopyQuantity({
    storeCopyQnt,
    storeCopy,
    config: resolvedConfig,
  });
};

export const validateMailingDate = ({
  mailing_date,
}: RRDMailingDateValidationArgs = {}) => {
  if (!mailing_date) {
    return "Mailing date is required";
  }

  return "";
};

export const validationSchema = (
  validLocations: RRDValidLocation[] = [],
  _campaign?: Record<string, any>
) => {
  return Yup.object(
    validLocations.reduce<Record<string | number, Yup.AnyObjectSchema>>(
      (acc, location) => {
        acc[location.id] = Yup.object({
          store_copy: Yup.boolean(),

          store_copy_qnt: Yup.mixed().test(
            "valid-quantity",
            "Enter a valid quantity",
            function (value, ctx) {
              // Get store_copy value from parent object
              const storeCopyValue = ctx.parent?.store_copy;

              // Only validate if store_copy is true
              if (!storeCopyValue) {
                return true;
              }

              const message = validateStoreCopyQuantity({
                storeCopyQnt: value,
                storeCopy: storeCopyValue,
                storeCopyConfig: ctx.parent,
              });

              if (message) {
                return this.createError({
                  message,
                });
              }

              return true;
            }
          ),
        });

        return acc;
      },
      {}
    )
  );
};
